import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import UtmZoneForm from '../Forms/UtmZoneForm';

const AddEditUtmZoneModal = ({
	dataUtmZone,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} UTM
			</ModalHeader>

			<UtmZoneForm
				dataUtmZone={dataUtmZone}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditUtmZoneModal;